import { useNavigate } from 'react-router-dom';

const useCustomAdminMobileMove = () => {
    const navigate = useNavigate();

    /* 뒤로 돌아가기 */
    const moveToBack = () => {
        window.history.back();
    };
    /* 메인으로 돌아가기 */
    const moveToHome = () => {
        navigate({ pathname: `/admin/mobile/` });
    };
    /* 상품 관리 */
    const moveToProduct = () => {
        navigate({ pathname: `/admin/mobile/product` });
    };
    /* 이벤트 관리 */
    const moveToEvent = () => {
        navigate({ pathname: `/admin/mobile/event` });
    };
    /* 공지 관리 */
    const moveToNotice = () => {
        navigate({ pathname: `/admin/mobile/notice` });
    };
    /* 가맹점 조회 */
    const moveToStoreSearch = () => {
        navigate({ pathname: `/admin/mobile/storeSearch` });
    };
    /* 점포별 매출 현황 */
    const moveToStoreSale = () => {
        navigate({ pathname: `/admin/mobile/storeSale` });
    };
    /* 카테고리 관리 */
    const moveToStoreCategory = () => {
        navigate({ pathname: `/admin/mobile/storeCate` });
    };
    /* 유저 관리 */
    const moveToUserManagement = () => {
        navigate({ pathname: `/admin/mobile/userManage` });
    };
    /* 자판기 관리 */
    const moveToMachManagement = () => {
        navigate({ pathname: `/admin/mobile/machManage` });
    };
    /* 통계 */
    const moveToStats = () => {
        navigate({ pathname: `/admin/mobile/stats` });
    };
    /* 발주관리 */
    const moveToOrder = () => {
        navigate({ pathname: `/admin/mobile/order` });
    };

    return {
        moveToBack,
        moveToHome,
        moveToProduct,
        moveToEvent,
        moveToNotice,
        moveToStoreSearch,
        moveToStoreSale,
        moveToStoreCategory,
        moveToUserManagement,
        moveToMachManagement,
        moveToStats,
        moveToOrder
    };
};

export default useCustomAdminMobileMove;
